module.exports = __webpack_public_path__ + "img/home-solution-shengtai.0b6f7669.png";